module.exports = __webpack_public_path__ + "static/media/archive.19b4f2a6.svg";